var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 4.5V19.5C21.375 19.9973 21.1775 20.4742 20.8258 20.8258C20.4742 21.1775 19.9973 21.375 19.5 21.375H4.5C4.00272 21.375 3.52581 21.1775 3.17417 20.8258C2.82254 20.4742 2.625 19.9973 2.625 19.5V4.5C2.625 4.00272 2.82254 3.52581 3.17417 3.17417C3.52581 2.82254 4.00272 2.625 4.5 2.625H19.5C19.9973 2.625 20.4742 2.82254 20.8258 3.17417C21.1775 3.52581 21.375 4.00272 21.375 4.5ZM19.125 4.875H4.875V19.125H19.125V4.875Z",
    fill: "#2C3E4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20981 13.1802C7.26644 13.317 7.34945 13.4412 7.4541 13.5459L9.7041 15.7949C9.80862 15.8998 9.93281 15.983 10.0696 16.0398C10.2063 16.0966 10.3529 16.1258 10.501 16.1258C10.649 16.1258 10.7957 16.0966 10.9324 16.0398C11.0691 15.983 11.1933 15.8998 11.2979 15.7949L16.5478 10.5449C16.7592 10.3336 16.8779 10.0469 16.8779 9.74805C16.8779 9.44916 16.7592 9.16251 16.5478 8.95117C16.3365 8.73983 16.0499 8.62109 15.751 8.62109C15.4521 8.62109 15.1654 8.73983 14.9541 8.95117L10.5 13.4062L9.04785 11.9521C8.9432 11.8475 8.81897 11.7645 8.68224 11.7078C8.54551 11.6512 8.39897 11.622 8.25098 11.622C8.10298 11.622 7.95644 11.6512 7.81971 11.7078C7.68298 11.7645 7.55875 11.8475 7.4541 11.9521C7.34945 12.0568 7.26644 12.181 7.20981 12.3177C7.15317 12.4544 7.12402 12.601 7.12402 12.749C7.12402 12.897 7.15317 13.0435 7.20981 13.1802Z",
    fill: "#2C3E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.751f84d992ec73af3375604f36dae803.svg";
export { ForwardRef as ReactComponent };